<template>
  <div>
    <Loader v-if="loader" />

    <div class="card col-12 welcome-card" style="padding: 15em; color:white; background-color: #1f5d38 ">
      <h2 class="welcome-title" style="text-align: center; font-size: 60px;">Benvenuto</h2>
      <span class="email" style="display: flex; justify-content: center; font-size: 20px; color: inherit;">{{ currentUser.email }}</span>
    </div>

      <div class="grid justify-content-around">
        <template v-if="showCaricamentoRcu">
          <CaricamentoRcu />
        </template>
        <template v-else>
          <div class="empty-state" v-show="showEmptyState">
            <p class="empty-state-message" style="font-size: 15px;">Seleziona dal menù laterale l'operazione da effettuare</p>
          </div>
        </template>
      </div>
    </div>

</template>

<script>
import { getCurrentInstance, onMounted, ref } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Loader from '@/components/Loader.vue'
import roles from '@/config/roles'
import { useRouter } from 'vue-router'
import CaricamentoRcu from '@/components/caricamentoFile/rcu/CaricamentoRcu.vue'


export default {
  components: {
    Loader,
    CaricamentoRcu
  },
  setup () {
    const router = useRouter()
    const loader = ref(false);
    const store = useStore()
    const currentUser = ref(store.state.auth.user)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const chartRefBanks = ref(null);
    const ctrs = ref({
      labels: [],
      datasets: [
          {
              label: 'Contratti Validi',
              backgroundColor: '#34d5eb',
              data: []
          },
          {
              label: 'Contratti Errati',
              backgroundColor: '#eb4f34',
              data: []
          },
          {
              label: 'Contratti Da Validare',
              backgroundColor: '#b3b3b3',
              data: []
          },    
      ]
    });

    const showCaricamentoRcu = ref(false);
    const showEmptyState = ref(true); 

    onMounted(() => {       
      getCtr();
    });

    const getCtr = async () => {
      // Implementazione della funzione getCtr
    };

    const goToPath = (id) => {
      switch (id) {
        case 'newContract':
          router.push({path: '/multisito'})
          break;
        case 'uploaded':
          router.push({path: '/caricamenti-multisito'})
          break;
      }
    }

    const exportChart = (refGraph) => {
      // Implementazione della funzione exportChart
    }

    return {
      ctrs,
      chartRefBanks,
      loader,
      currentUser,
      roles,
      exportChart,
      goToPath,
      showCaricamentoRcu,
      showEmptyState
    }
  }
}
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: 20px;
}

.empty-state-message {
  font-size: 1.5rem;
  color: #000000; 
  background: linear-gradient(to right, transparent 0%, #04ba2e 100%);
  background-clip: text; 
  -webkit-background-clip: text; 
  animation: colorize 2s infinite linear; 
}

@keyframes colorize {
  0% {
    background-position: -200%;
  }
  100% {
    background-position: 200%;
  }
}
</style>
